import React, { useState, useEffect, lazy } from 'react';
//const fs = require('fs');

import {useSelector} from 'react-redux';
import BackgroundImage from './BackgroundImage.js';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box'
import CustomizedBreadcrumbs2 from './Breadcrumbs2.js';
import SplitButton2 from './splitButton2.js';


export default function FTPSettings({}){

  const { user } = useSelector((state) => state.auth); 
  const[dashboardName, setDashboardName] = useState("Batch"); // This "Dashboard" Vlaue will open the dashboard bydefault with name "Dashboard"
  const[widgetName, setWidgetName] = useState();
  const[widgetGroupName, setWidgetGroupName] = useState();
  //Import() to call function or component with dynamic path value
  let projectname = user.selectedproject;
  let dashboardType = "BatchData";

//Here.catch used, if dasboardName file does not exist then will display the BackgroundImage.js content to avoid the error.
//only accepting last name of file path as variable, otherwise giving error
  const ImportCompo = lazy(() => import(`./../pages/BatchData/${dashboardName}`).catch((err) => {  
  return import('./BackgroundImage.js');
  }),
  );


  const handleSelectedDashboard = (value) => {
    //console.log(value);
    setDashboardName(value);
  };

  const handleSelectedWidgetGroup =(value) => {
    //console.log(value)
    setWidgetGroupName(value);

  };

  const handleSelectedWidget = (value) => {
    //console.log(value);
    setWidgetName(value);
  };

  const isSplitButton2Access = user && user.UserAccess && user.UserAccess[55] && user.UserAccess[55].Enable === "Enabled" && user.UserAccess[55].Options 
  ? user.UserAccess[55].Options.includes(user.role)
  : false; // Default to false if user or the necessary properties are null or undefined
 
  return (
    
    <div >
      {/* <Box sx={{height: 85 }}>  </Box> */}

        <Box sx={{mt:1, height: 50}} >
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{backgroundColor: 'transparent'}}>
          <Grid item xs={10}>           
            <CustomizedBreadcrumbs2
            projectName={projectname}
            dashboardType={dashboardType}
            selectedDashboardGroup = {handleSelectedWidgetGroup}
            selectedDashboard = {handleSelectedWidget}
            />

          </Grid>
          <Grid item xs={2} justifyContent="center">
          {( isSplitButton2Access || user.role === "engineer"  || user.role === "superadmin") && (
          <SplitButton2
          projectName={projectname}
          dashboardType={dashboardType}
          selectedDashboard = {handleSelectedDashboard}
          />
          )}
          </Grid>
          
          
          {/* <Grid item xs={4}> <DateTimeDisplay/>  </Grid> */}
        </Grid>
        </Box>

      
      
    {/* Selected page or dashboard content */}

    {dashboardName ? (
      <React.Suspense fallback={<>...</>}>
      <ImportCompo/>
    </React.Suspense>
    ):(
      <BackgroundImage/>
    )}
        
    </div>


  );
}